/* Utils */
import { createDeferredPromise } from '~/utils/createDeferredPromise';
import widevineProto from './widevine.proto?url';

let decodersDeferred;
export async function getWidevineDecoders() {
  if (decodersDeferred) return decodersDeferred.promise;

  decodersDeferred = createDeferredPromise();
  try {
    const { load } = await import('protobufjs');
    const root = await load(widevineProto);

    const { MessageType } = root.SignedMessage;
    const DecodersByMessageType = {
      [MessageType.LICENSE_REQUEST]: root.LicenseRequest,
      [MessageType.LICENSE]: root.License,
      [MessageType.ERROR_RESPONSE]: root.LicenseError,
      [MessageType.SERVICE_CERTIFICATE]: root.SignedDeviceCertificate,
    };

    decodersDeferred.resolve({
      ...root.nested,
      DecodersByMessageType,
    });
  } catch (error) {
    decodersDeferred.reject(error);
  }

  return decodersDeferred.promise;
}

const toObjectOptions = {
  enums: String,
  bytes: String,
  longs: String,
};

export async function decodeSignedMessage(buffer) {
  const { SignedMessage, DecodersByMessageType } = await getWidevineDecoders();
  const decodedSignedMessage = SignedMessage.decode(new Uint8Array(buffer));
  const objectSignedMessage = SignedMessage.toObject(decodedSignedMessage, toObjectOptions);

  if (objectSignedMessage.msg) {
    const decoder = DecodersByMessageType[decodedSignedMessage.type];
    if (!decoder) {
      throw new Error(`Unsupported message type ${objectSignedMessage.type}`);
    }

    objectSignedMessage.msg = decoder.toObject(
      decoder.decode(decodedSignedMessage.msg),
      toObjectOptions,
    );
  }

  return objectSignedMessage;
}
